import { f as n } from "./index743.mjs";
import { r as s } from "./index751.mjs";
import { t as c } from "./index749.mjs";
import { w as m } from "./index823.mjs";
var p = n, f = s, u = c, e = m, a = p("".replace), v = RegExp("^[" + e + "]+"), g = RegExp("(^|[^" + e + "])[" + e + "]+$"), t = function(i) {
  return function(o) {
    var r = u(f(o));
    return i & 1 && (r = a(r, v, "")), i & 2 && (r = a(r, g, "$1")), r;
  };
}, w = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: t(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: t(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: t(3)
};
export {
  w as s
};
